// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { FormsInfo } from '../../../components/formsInfo/index';
import { Message } from '../../../components/message/index';
import { Note } from '../../../components/note/index';
import { BtnSmall } from '../../../components/btns/btnSmall';
// reducer
import {
  componentStatesInitialState,
  componentStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';
/***************************************************************************/
/* Name : FormsDownload React Component */
/***************************************************************************/
const DocumentDownloadPage = React.memo(() => {
  const navigate = useNavigate();
  const [api_url, setApi_url] = useState(
    useSelector((state) => state.ui.api_url)
  );
  // isPassed
  const [isPassed, setIsPassed] = useState(
    useSelector((state) => state.ui.studentObj.isPassed)
  );
  // student data
  const [studentData, setStudentData] = useState(
    useSelector((state) => state.ui.studentData)
  );

  // reducer
  const [componentStates, dispatchComponentStates] = useReducer(
    componentStatesReducer,
    componentStatesInitialState
  );
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      if (studentData.length === 0) {
        // navigate to dashboard
        navigate('/');
      }
      if (isPassed) {
        // navigate to dashboard
        navigate('/dashboard/studentDataView');
      }
    })();
  }, []);
  /******************************************************************/
  /* downloadFormsHadler2 */
  /******************************************************************/
  const downloadFormsHadler = async () => {
    // it opens pdf can i make it download
    window.location.href = `${api_url}/api/v1/students/getStudentBook`;
  };
  /******************************************************************/
  /* handleCloseSnackbar */
  /******************************************************************/
  const handleCloseSnackbar = () => {
    dispatchComponentStates({ type: 'CLEAR' });
  };
  return (
    <Fragment>
      <NavHeader title={'تنزيل الاستمارات '} />
      <div className={styles['inner-container']}>
        <br />
        <FormsInfo
          data={[
            {
              name: 'استمارة ',
              value: 'pdf.ميثاق الطالب الجامعي',
            },
          ]}
        />
        <BtnSmall title={'تنزيل '} onClick={downloadFormsHadler} />
        <Note
          text={
            'برجاء قراءة الميثاق جيدا وسوف تقوم بحل اختبار من اربع اسئلة للاستمرار في استكمال البيانات'
          }
        />
        {!isPassed && (
          <BtnSmall
            title={'الاختبار '}
            onClick={() => {
              navigate('/dashboard/quiz');
            }}
          />
        )}
      </div>
      {componentStates.pending && (
        <Message text={'يتم الان معالجة البيانات'} type='load' />
      )}
      {/* ********** SUCCESS SNACKBAR ********** */}
      <Snackbar
        open={componentStates.success}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='success'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#43A047',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.successMessage}
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={componentStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{componentStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { DocumentDownloadPage };
